import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store/public'

Vue.use(Router);

const homePage = () => import('@/views/public/Home')
const allPages = () => import('@/views/public/Pages')
const contactPage = () => import('@/views/public/Contact')

const router = new Router({
	history: true,
	routes: [
		{
			path: '/',
			name: 'default',
			redirect: { name: 'home' }
		},
		{
			path: '/home',
			name: 'home',
			component: homePage
		},	
		{
			path: '/contact',
			name: 'contact',			
			component: contactPage
		},	
		{
			path: '*',
			name: 'allPages',
			component: allPages
		}	
	]
});
	
router.beforeEach(async (to, _from, next) => {
	if (!store.getters.appLoaded)
		await store.dispatch('init')	
	next()
})

export default router
